export const chunk = (array, chunckSize) =>
  array.reduce(
    (accumulator, _, index, residualArray) =>
      !(index % chunckSize)
        ? accumulator.concat([residualArray.slice(index, index + chunckSize)])
        : accumulator,
    []
  );

export const getMoneyValue = value => {
  if (typeof value === "string") {
    const replaceValue = parseFloat(
      value
        .replace("R$", "")
        // .replace(".", "")
        .replace(",", ".")
    );
    return isNaN(replaceValue) ? 0 : replaceValue;
  }
  return value;
};

export async function asyncForEach(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}

export const toLocaleMoney = value =>
  value &&
  value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });



// WEBPACK FOOTER //
// ./src/shared/utils/functional.utils.js